<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>产品管理</span>
          <el-button v-if="$hasPerm('func:product:create')" type="primary" @click="openDialog()" style="float: right" size="small">添加产品</el-button>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="产品名称">
          <el-input v-model="searchForm.name" placeholder="请输入产品名称" style="width: 180px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="searchForm.categoryId" placeholder="请选择" clearable style="width: 140px">
            <el-option v-for="c in categoryList" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试用类型">
          <el-select v-model="searchForm.applicableTypeId" placeholder="全部" clearable style="width: 140px" @change="handleSearch">
            <el-option v-for="t in applicableTypeList" :key="t.id" :label="t.name" :value="t.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="productList" style="width: 100%" stripe>
        <el-table-column type="expand" width="40">
          <template slot-scope="props">
            <div class="prod-expand">
              <div class="prod-expand-title"><i class="el-icon-info"></i><span>产品详情</span></div>
              <div class="prod-expand-grid">
                <div class="dc-cell"><span class="dc-label">产品ID</span><span class="dc-value">{{ props.row.id }}</span></div>
                <div class="dc-cell"><span class="dc-label">产品名称</span><span class="dc-value">{{ props.row.name || '-' }}</span></div>
                <div class="dc-cell"><span class="dc-label">产品编码</span><span class="dc-value">{{ props.row.code || '-' }}</span></div>
                <div class="dc-cell"><span class="dc-label">分类</span><span class="dc-value">{{ getCategoryName(props.row.categoryId) || '-' }}</span></div>
                <div class="dc-cell"><span class="dc-label">规格</span><span class="dc-value">{{ props.row.spec || '-' }}</span></div>
                <div class="dc-cell"><span class="dc-label">价格</span><span class="dc-value">¥{{ props.row.price || 0 }}</span></div>
                <div class="dc-cell"><span class="dc-label">排序值</span><span class="dc-value">{{ props.row.sortOrder != null ? props.row.sortOrder : 0 }}</span></div>
                <div class="dc-cell"><span class="dc-label">库存上限</span><span class="dc-value">{{ props.row.stockLimit != null ? props.row.stockLimit : '-' }}</span></div>
                <div class="dc-cell"><span class="dc-label">预警阈值</span>
                  <el-tag type="warning" size="mini">{{ props.row.warningThreshold != null ? props.row.warningThreshold : 100 }}</el-tag>
                </div>
                <div class="dc-cell"><span class="dc-label">库存</span>
                  <el-tag :type="Number(props.row.stock || 0) <= 0 ? 'danger' : 'success'" size="mini">{{ props.row.stock || 0 }}</el-tag>
                </div>
                <div class="dc-cell dc-cell-full">
                  <span class="dc-label">试用类型与独立次数</span>
                  <div v-if="props.row.applicableTypeList && props.row.applicableTypeList.length" style="display:inline-flex; gap:6px; flex-wrap:wrap">
                    <el-tag
                      v-for="t in props.row.applicableTypeList"
                      :key="t.applicableTypeId"
                      :color="t.applicableTypeColor || ''"
                      :style="t.applicableTypeColor ? 'color:#fff;border-color:' + t.applicableTypeColor : ''"
                      size="mini"
                    >
                      {{ t.applicableTypeName }}（{{ t.applicableCount ? t.applicableCount + '次' : '不限次数' }}）
                    </el-tag>
                  </div>
                  <span v-else class="dc-value">-</span>
                </div>
                <div class="dc-cell dc-cell-full"><span class="dc-label">描述</span><span class="dc-value">{{ props.row.description || '-' }}</span></div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="产品名称" min-width="130"></el-table-column>
        <el-table-column prop="code" label="产品编码" width="110"></el-table-column>
        <el-table-column label="分类" width="85" align="center">
          <template slot-scope="scope">{{ getCategoryName(scope.row.categoryId) }}</template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="80" align="center" sortable>
          <template slot-scope="scope">
            <el-tag size="mini" type="info">{{ scope.row.sortOrder != null ? scope.row.sortOrder : 0 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格" width="90">
          <template slot-scope="scope">¥{{ scope.row.price || 0 }}</template>
        </el-table-column>
        <el-table-column prop="stockLimit" label="库存上限" width="90" align="center">
          <template slot-scope="scope">{{ scope.row.stockLimit != null ? scope.row.stockLimit : '-' }}</template>
        </el-table-column>
        <el-table-column label="预警阈值" width="95" align="center">
          <template slot-scope="scope">
            <el-tag type="warning" size="mini">{{ scope.row.warningThreshold != null ? scope.row.warningThreshold : 100 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="试用类型及次数" min-width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.applicableTypeList && scope.row.applicableTypeList.length" style="display:flex; flex-wrap:wrap; gap:4px">
              <el-tag
                v-for="t in scope.row.applicableTypeList"
                :key="t.applicableTypeId"
                :color="t.applicableTypeColor || ''"
                :style="t.applicableTypeColor ? 'color:#fff;border-color:' + t.applicableTypeColor : ''"
                size="mini"
              >
                {{ t.applicableTypeName }}: {{ t.applicableCount ? t.applicableCount + '次' : '不限' }}
              </el-tag>
            </div>
            <el-tag
              v-else-if="scope.row.applicableTypeName"
              :color="scope.row.applicableTypeColor || ''"
              :style="scope.row.applicableTypeColor ? 'color:#fff;border-color:' + scope.row.applicableTypeColor : ''"
              size="mini"
            >
              {{ scope.row.applicableTypeName }}: {{ scope.row.applicableCount ? scope.row.applicableCount + '次' : '不限' }}
            </el-tag>
            <span v-else style="color:#909399">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="stock" label="库存" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="Number(scope.row.stock || 0) <= 0 ? 'danger' : 'success'" size="mini">{{ scope.row.stock || 0 }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="$hasPerm('func:product:edit')" type="primary" size="mini" @click="openDialog(scope.row)">修改</el-button>
            <el-button v-if="$hasPerm('func:product:delete')" type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-4">
        <el-pagination @size-change="s => { pageSize = s; getProductList() }" @current-change="p => { currentPage = p; getProductList() }" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>

    <el-dialog :title="form.id ? '编辑产品' : '添加产品'" :visible.sync="dialogVisible" width="680px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="90px" size="small">
        <el-form-item label="产品名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="categoryId">
          <el-select v-model="form.categoryId" placeholder="请选择分类" style="width: 100%">
            <el-option v-for="c in categoryList" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="规格">
              <el-input v-model="form.spec" placeholder="如 500g/瓶" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="价格" prop="price">
              <el-input-number v-model="form.price" :min="0" :precision="2" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="库存" prop="stock">
              <el-input-number v-model="form.stock" :min="0" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="库存上限">
              <el-input-number v-model="form.stockLimit" :min="0" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="预警阈值">
              <el-input-number v-model="form.warningThreshold" :min="0" controls-position="right" placeholder="不填默认 100" style="width: 100%"></el-input-number>
              <span class="muted small" style="display:block;color:#909399;font-size:12px;line-height:1.4;margin-top:4px">库存低于该值进入待办提醒</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序值">
              <el-input-number v-model="form.sortOrder" :min="0" :step="1" controls-position="right" placeholder="数字越小越靠前" style="width: 100%"></el-input-number>
              <span class="muted small" style="display:block;color:#909399;font-size:12px;line-height:1.4;margin-top:4px">数字越小越靠前（默认0）</span>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 试用类型配置 -->
        <div class="trial-section-box">
          <div class="trial-section-header">
            <span class="section-title"><i class="el-icon-connection"></i> 试用类型与独立次数设置</span>
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="addTrialTypeRow">添加试用类型</el-button>
          </div>
          <div v-if="!form.applicableTypeList || !form.applicableTypeList.length" class="trial-empty-tip">
            <i class="el-icon-warning-outline"></i> 暂未配置试用类型（该产品将不支持试用申请；若需支持，请点击右上角添加）
          </div>
          <div v-else class="trial-row-container">
            <div v-for="(item, idx) in form.applicableTypeList" :key="idx" class="trial-row-item">
              <span class="row-index">#{{ idx + 1 }}</span>
              <div class="trial-field">
                <span class="field-label">试用类型：</span>
                <el-select
                  v-model="item.applicableTypeId"
                  placeholder="选择类型"
                  size="small"
                  style="width: 180px"
                  @change="onTrialTypeSelect(item)"
                >
                  <el-option
                    v-for="t in applicableTypeList"
                    :key="t.id"
                    :label="t.name"
                    :value="t.id"
                    :disabled="isTypeSelected(t.id, idx)"
                  >
                    <span style="float: left">{{ t.name }}</span>
                    <span v-if="t.color" :style="'float: right; width: 14px; height: 14px; margin-top: 8px; border-radius: 2px; background: ' + t.color"></span>
                  </el-option>
                </el-select>
              </div>
              <div class="trial-field">
                <span class="field-label">次数上限：</span>
                <el-input-number
                  v-model="item.applicableCount"
                  :min="0"
                  :step="1"
                  controls-position="right"
                  size="small"
                  placeholder="0为不限"
                  style="width: 110px"
                ></el-input-number>
                <span class="field-hint">次 (0为不限)</span>
              </div>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                size="mini"
                @click="removeTrialTypeRow(idx)"
              ></el-button>
            </div>
          </div>
        </div>

        <el-form-item label="描述" style="margin-top: 10px">
          <el-input v-model="form.description" type="textarea" placeholder="请输入描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { productApi, categoryApi, applicableTypeApi } from '../api/api'

export default {
  data() {
    return {
      productList: [],
      categoryList: [],
      applicableTypeList: [],
      searchForm: { name: '', categoryId: '', applicableTypeId: '' },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      form: {},
      rules: {
        name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择分类', trigger: 'change' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getProductList()
    this.loadCategories()
    this.loadApplicableTypes()
  },
  methods: {
    getProductList() {
      productApi.getProductPage(
        this.currentPage,
        this.pageSize,
        this.searchForm.name,
        this.searchForm.categoryId,
        this.searchForm.applicableTypeId || null
      ).then(res => {
        this.productList = res.data.records || []
        this.total = res.data.total || this.productList.length
      })
    },
    loadCategories() {
      categoryApi.getCategoryList().then(res => { this.categoryList = res.data || [] })
    },
    loadApplicableTypes() {
      applicableTypeApi.getApplicableTypeList(1).then(res => { this.applicableTypeList = res.data || [] })
    },
    getCategoryName(id) {
      const c = this.categoryList.find(x => x.id === id)
      return c ? c.name : (id || '—')
    },
    handleSearch() { this.currentPage = 1; this.getProductList() },
    openDialog(row) {
      this.loadCategories()
      this.loadApplicableTypes()
      if (row) {
        let list = []
        if (row.applicableTypeList && row.applicableTypeList.length) {
          list = JSON.parse(JSON.stringify(row.applicableTypeList))
        } else if (row.applicableTypeId) {
          list = [{ applicableTypeId: row.applicableTypeId, applicableCount: row.applicableCount || 0 }]
        }
        this.form = { ...row, sortOrder: row.sortOrder != null ? row.sortOrder : 0, applicableTypeList: list }
      } else {
        this.form = { stock: 0, price: 0, sortOrder: 0, applicableTypeList: [] }
      }
      this.dialogVisible = true
    },
    addTrialTypeRow() {
      if (!this.form.applicableTypeList) {
        this.$set(this.form, 'applicableTypeList', [])
      }
      const selectedIds = this.form.applicableTypeList.map(x => x.applicableTypeId)
      const available = this.applicableTypeList.find(t => !selectedIds.includes(t.id))
      this.form.applicableTypeList.push({
        applicableTypeId: available ? available.id : null,
        applicableCount: 0,
        applicableTypeName: available ? available.name : '',
        applicableTypeColor: available ? available.color : ''
      })
    },
    removeTrialTypeRow(idx) {
      this.form.applicableTypeList.splice(idx, 1)
    },
    isTypeSelected(typeId, currentIdx) {
      if (!this.form.applicableTypeList) return false
      return this.form.applicableTypeList.some((item, idx) => idx !== currentIdx && item.applicableTypeId === typeId)
    },
    onTrialTypeSelect(item) {
      const found = this.applicableTypeList.find(t => t.id === item.applicableTypeId)
      if (found) {
        item.applicableTypeName = found.name
        item.applicableTypeColor = found.color
      }
    },
    handleDelete(id) {
      this.$confirm('确定要删除该产品吗？', '提示', { type: 'warning' }).then(() => {
        productApi.deleteProduct(id).then(res => {
          if (res.data) {
            this.$message.success('删除成功')
            this.getProductList()
          } else {
            this.$message.error('删除失败')
          }
        }).catch(err => {
          this.$message.error((err.response && err.response.data && err.response.data.message) || '删除失败')
        })
      }).catch(() => {})
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        if (this.form.applicableTypeList) {
          this.form.applicableTypeList = this.form.applicableTypeList.filter(t => t.applicableTypeId != null)
        }
        const api = this.form.id ? productApi.updateProduct(this.form) : productApi.addProduct(this.form)
        api.then(res => {
          if (res.data) {
            this.$message.success(this.form.id ? '更新成功' : '添加成功')
            this.dialogVisible = false
            this.getProductList()
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; }
.prod-expand { padding: 6px 18px 14px 18px; background: #fafbfc; border-radius: 6px; }
.prod-expand-title { font-weight: 600; color: var(--theme-primary, #2793FF); margin-bottom: 8px; font-size: 14px; }
.prod-expand-title i { margin-right: 6px; }
.prod-expand-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; }
.prod-expand-grid .dc-cell { display: flex; align-items: center; gap: 8px; padding: 6px 10px; background: #fff; border-radius: 4px; border: 1px solid #ebeef5; font-size: 13px; }
.prod-expand-grid .dc-cell.dc-cell-full { grid-column: span 4; }
.prod-expand-grid .dc-label { color: #909399; font-size: 12px; flex-shrink: 0; }
.prod-expand-grid .dc-label::after { content: '：'; }
.prod-expand-grid .dc-value { color: #303133; }

/* 试用类型配置区域 */
.trial-section-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 14px;
  margin: 8px 0 12px 10px;
}
.trial-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.section-title {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}
.section-title i {
  color: #409eff;
  margin-right: 4px;
}
.trial-empty-tip {
  color: #94a3b8;
  font-size: 12px;
  padding: 6px 0;
}
.trial-row-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.trial-row-item {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 6px 10px;
}
.row-index {
  color: #94a3b8;
  font-size: 12px;
  font-weight: bold;
}
.trial-field {
  display: flex;
  align-items: center;
  gap: 4px;
}
.field-label {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}
.field-hint {
  font-size: 12px;
  color: #94a3b8;
  white-space: nowrap;
}
</style>
